const getAppTranslationsScopes = [
  'APP_TRANSLATIONS_GLOBAL',
];
const chains = [];
chains.push({ _operation: 'getAppTranslations', api: '/app/translations', defaultData: [], httpVerb: 'get', scopes: getAppTranslationsScopes });
chains.push({ _operation: 'updateTranslationById', api: '/app/translation/:objectId', defaultData: [], httpVerb: 'patch' });
export default chains;
